/* eslint-disable import/prefer-default-export */
import Dialog from "../../../components/Dialog";
import { SuccessModalIcon } from "../../../components/Icons";
import {
    DialogTitle,
    DialogText,
    DialogButtonWrapper,
    DialogAcceptButton,
    DialogCancelButton,
} from "../../../styles/components/PromisifiedDialogStyles";

interface IProps {
    openModal: boolean;
    handleClose: () => void;
    modalTitle: string;
    modalText?: string;
    acceptButtonText?: string;
    declineButtonText?: string;
}

const DialogConfirm: React.FC<IProps> = ({
    openModal,
    handleClose,
    modalTitle,
    modalText,
    acceptButtonText,
    declineButtonText,
}) => {
    return (
        <Dialog
            openModal={openModal}
            onHide={handleClose}
            modalIcon={<SuccessModalIcon />}
        >
            <DialogTitle>{modalTitle}</DialogTitle>
            {modalText && <DialogText>{modalText}</DialogText>}
            <DialogButtonWrapper>
                <DialogAcceptButton type="button" onClick={handleClose}>
                    {acceptButtonText || "Ok"}
                </DialogAcceptButton>
            </DialogButtonWrapper>
            {declineButtonText && (
                <DialogButtonWrapper>
                    <DialogCancelButton type="button" onClick={handleClose}>
                        {declineButtonText}
                    </DialogCancelButton>
                </DialogButtonWrapper>
            )}
        </Dialog>
    );
};

export { DialogConfirm };
